import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import ErrorToast from "../../common/ErrorToast";
import Upload from "../../../components/Upload";
import "react-bootstrap-typeahead/css/Typeahead.css";
import {getFiles, getFileTypes, updateSystemFile} from "../../../actions/admin/systemFileActions";
import SuccessToast from "../../common/SuccessToast";
import {Table} from "../../../components/tables";
import {SortableTh} from "../../../components/SortableTh";
import {formatDateTime} from "../../../utils/util";

const componentName = "UploadSystemFile";

export const UploadSystemFile = () => {
    const isEmpty = require("is-empty");
    const dispatch = useDispatch();
    const { fileTypes } = useSelector((state) => state.systemFile);
    const { files } = useSelector((state) => state.systemFile);
    const errors = useSelector((state) => state.errors);
    const success = useSelector(state => state.success);
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [fileType, setFileType] = useState("");

    useEffect(() => {
        dispatch(getFileTypes(setFileType));
    }, [dispatch]);

    useEffect(() => {
        if (!isEmpty(fileType)) {
            dispatch(getFiles(fileType));
        }
    }, [dispatch, fileType, isEmpty]);

    const setFileMethod = async (file) => {
        if(file?.name){
            setFileName(file.name)
        }
        if (file) {
            const fileBuffer = await file.arrayBuffer();
            setFile(fileBuffer);
        }
    };

    const changeFileType = (fileType) => {
        setFileType(fileType);
    };

    return (
        <Row className="container-fluid p-3">
            <Col>
                <Card>
                    <Card.Body>
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mb-3">
                            <div className="d-flex flex-column w-100">
                                <Form.Label>
                                    <span id={`${componentName}-fileTypeLabel`}>File Type</span>
                                </Form.Label>
                                <select
                                    className="form-select"
                                    name="fileTypeValue"
                                    onChange={(e) => changeFileType(e.target.value)}
                                    id={`${componentName}-fileTypeValue`}
                                >
                                    {fileTypes.map((entry) => <option key={entry.value} value={entry.value}>{entry.text}</option>)}
                                </select>
                            </div>
                            <div className="d-flex flex-column w-100">
                                <Form.Label>
                                    <span id={`${componentName}-uploadFileLabel`}>Choose File</span>
                                </Form.Label>
                                <Upload
                                    id={`${componentName}-uploadFile`}
                                    fileName={fileName}
                                    setFile={setFileMethod}
                                    accept="application/pdf"
                                >
                                </Upload>
                            </div>
                            <Button id={`${componentName}-confirmButton`} variant="primary" disabled={isEmpty(file)} onClick={() => dispatch(updateSystemFile(fileType, file, fileName))}>
                                Confirm
                            </Button>
                        </div>
                        {errors?.message && <ErrorToast/>}
                        {success?.message && <SuccessToast />}
                        {files?.length ? (
                            <div className="d-flex flex-column gap-3">
                                <Table className="table-bordered">
                                    <thead className="table-light">
                                    <tr>
                                        <SortableTh columnName="Uploaded On" id={`${componentName}-uploadedOnColLabel`}/>
                                        <SortableTh columnName="Uploaded By" id={`${componentName}-uploadedByColLabel`}/>
                                        <SortableTh columnName="File Name" id={`${componentName}-fileNameColLabel`}/>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {files.map((file, idx) => {
                                            return (
                                                <tr key={`${file.id || file.fileName || "file"}-${file.created || ""}-${idx}`}>
                                                    <td id={`${componentName}-uploadedOnValue-${idx}`}>{file.created ? formatDateTime(file.created) : null}</td>
                                                    <td id={`${componentName}-uploadedByValue-${idx}`}>{file.creator}</td>
                                                    <td id={`${componentName}-fileNameValue-${idx}`}>{file.fileName}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                        ) : null}
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};
